export default "__VITE_ASSET__SaTpFKDq__"